import { Link } from 'react-router-dom';
import { Phone, Calendar } from 'lucide-react';

const MobileCTA = () => {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]">
      <div className="grid grid-cols-2 gap-2 p-3">
        <a
          href="tel:+13215004545"
          className="flex items-center justify-center px-4 py-3 bg-white border border-brand text-brand rounded-full font-medium text-sm"
          data-testid="mobile-cta-call"
          onClick={() => {
            if (typeof window !== 'undefined' && window.gtag) {
              window.gtag('event', 'call_click', { event_category: 'engagement' });
            }
          }}
        >
          <Phone className="h-4 w-4 mr-2" />
          Call Now
        </a>
        <Link
          to="/contact"
          className="flex items-center justify-center px-4 py-3 bg-brand text-white rounded-full font-medium text-sm"
          data-testid="mobile-cta-appointment"
        >
          <Calendar className="h-4 w-4 mr-2" />
          Book
        </Link>
      </div>
    </div>
  );
};

export default MobileCTA;
